<h2 mat-dialog-title>Detection</h2>
<mat-dialog-content>
  <img [src]="url" alt="Detection" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="warn" mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
